
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CelebrationIcon from '@mui/icons-material/Celebration';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import SurroundSoundIcon from '@mui/icons-material/SurroundSound';
import TtkList from './TtkList';
const MagicianTTK = ({ data }) => {
    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p><WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p><TravelExploreIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>No. of Events Covered :</b>&nbsp;<span>{data?.coverdofevents}</span></p>
                        </div>
                        <div className='col-md-4'>
                            <p><LocationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Areas of Services :</b>&nbsp;<TtkList data={data?.areaOfWorking} /></p>
                        </div>
                    </div>
                    <div className='row mb-1'>
                        <div className='col-md-4'>
                            <p><AccessTimeFilledIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Duration of the Show :</b>&nbsp;<TtkList data={data?.duration} /></p>
                        </div>
                        <div className='col-md-4'>
                            <p><SurroundSoundIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Requirements :</b>&nbsp;<TtkList data={data?.requirement} /></p>
                        </div>
                        {/* <div className='col-md-4'>
                            <p><TravelExploreIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Travel Preference :</b>&nbsp;<TtkList data={data?.travelPreference} /></p>
                        </div> */}
                        <div className='col-md-4'>
                            <p><CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Event Type :</b>&nbsp;<TtkList data={data?.eventtype} /></p>
                        </div>
                    </div>
                </div>
            </div>


        </>

    )
}

export default MagicianTTK